import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';

const WindowHeader = (props: any) => {

    const { title, onClose } = props;

    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <div className='cold-12 col-md-12'>
            <div className="position-relative bg-primary text-white p-3 text-center">

                <h5 className="m-0">
                    {title}
                </h5>
                {
                    onClose && <>
                        <button
                            className="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y me-3"
                            onClick={(event) => { onClose(event) }}
                        >
                            Cerrar
                        </button>

                    </>
                }

            </div>
        </div>

    );
}

export default WindowHeader;


